<template>
	<Modal :id="id" title="Write-In Attendee">
		<div slot="body" class="modal-body modal-form">
			<div class="row">
				<div class="col-12">
					<Alert v-if="hasAlert" :alert="alert"/>
				</div>

				<template v-if="event">
					<div class="col-12 mb-2">
						<Field
							v-if="isUpdate || isDealer"
							type="text"
							name="company"
							label="Company"
							:value="company.label"
							:disabled="true"
							validate="required"
						/>
						<SuggestField
							v-else
							name="company"
							label="Company"
							v-model="company"
							search-input-text="Search by company name or HVAC ID"
							:search-url="route('enroll.company.search', { event: event.id })"
							:search-params="companySearchParams"
							validate="required"
						/>
					</div>
					<div class="col-12 mb-3">
						<template v-if="brandOptions.length == 1">
							<Field
								type="text"
								name="brand"
								label="Brand"
								:value="brandOptions[0].label"
								:disabled="true"
								validate="required"
							/>
						</template>
						<template v-else>
							<Field
								type="select"
								name="brand"
								label="Brand"
								v-model="brandId"
								validate="required"
								:options="brandOptions"
								:hide-select-empty-option="true"
							/>
						</template>
					</div>
					<div class="col-12 mb-3">
						<Field
							type="text"
							name="first_name"
							label="First Name"
							v-model="firstName"
							validate="required"
						/>
					</div>
					<div class="col-12 mb-3">
						<Field
							type="text"
							name="last_name"
							label="Last Name"
							v-model="lastName"
							validate="required"
						/>
					</div>
					<div class="col-12 mb-3">
						<Field type="text" name="email" label="Email" v-model="email"/>
					</div>
				</template>
			</div>
		</div>

		<div slot="footer" class="modal-footer">
			<a class="btn btn-success" href="#" @click.prevent="submit()">
				{{ isUpdate ? "Update Write-In" : "Save Write-In" }}
			</a>
			<a class="btn btn-info" href="#" @click.prevent="close()">Cancel</a>
		</div>
	</Modal>
</template>

<script>
import DisplaysAlerts from "mixins/DisplaysAlerts";
import ModalMixin from "mixins/Modal";

export default {
	mixins: [DisplaysAlerts, ModalMixin],

	data() {
		return {
			id: "writein-modal",
			event: null,
			user: null,
			company: null,
			brandId: null,
			firstName: "",
			lastName: "",
			email: "",
			originalBrandOptions: [],
			companySearchParams: {
				...{"pagination[current]": 1},
				...{"pagination[per_page]": 10},
				...{"sort[column]": "name"},
				...{"sort[dir]": "asc"},
			},
		};
	},

	computed: {
		isUpdate() {
			return !!this.user;
		},
		isDealer() {
			return this.$root.user.company.type === this.$root.constants.DEALER_COMPANY;
		},
		brandOptions() {
			if (!this.event || !this.event.availableBrands) {
				return [];
			} else if (!this.company || !this.company.brands) {
				return this.event.availableBrands;
			}
			if (!this.$root.isAdmin) {
				return this.event.availableBrands.filter((eb) => {
					return !!this.company.brands.find((cb) => cb.value == eb.value);
				});
			} else {
				if (this.company.brands.length) {
					return this.company.brands.map((brand) => {
						return {
							label: brand.name,
							value: brand.id
						}
					});
				}
			}
		},
		selectedBrand() {
			if (!this.brandId || this.brandOptions.length == 0) {
				return null;
			} else {
				return {
					id: this.brandId,
					name: this.brandOptions.find((b) => b.value == this.brandId).label,
				};
			}
		},
	},

	watch: {
		user(obj) {
			this.load();
		},
		brandOptions(arr) {
			if (arr.length == 1) {
				this.brandId = arr[0].value;
			}
		},
	},

	methods: {
		load() {
			if (_.isObject(this.user)) {
				this.company = {
					value: this.user.company.id,
					label: this.user.company.name,
				};
				this.brandId = this.user.selectedBrand.id;
				this.firstName = this.user.first_name;
				this.lastName = this.user.last_name;
				this.email = this.user.email;
			}
		},
		validate() {
			return !(
				!this.company ||
				!this.brandId ||
				!this.firstName ||
				!this.lastName
			);
		},
		store() {
			var url = !!this.user
				? this.route("enroll.writein.update", {user: this.user.id})
				: this.route("enroll.writein.store");
			var post = {
				write_in: {
					company_id: this.company.value,
					first_name: this.firstName,
					last_name: this.lastName,
					email: this.email,
				},
			};
			return this.axios.post(url, post);
		},
		submit() {
			if (!this.validate()) {
				alert(`Please fill in all required fields before continuing`);
			} else {
				this.store()
					.then((response) => {
						var user = response.data;
						user.enrollableBrands = _.cloneDeep(this.brandOptions);
						user.selectedBrand = _.cloneDeep(this.selectedBrand);
						this.resolve(user, true);

						this.firstName = "";
						this.lastName = "";
						this.email = "";
					})
					.catch((error) => {
						this.parseErrors(error.response.data.errors);
					});
			}
		},
	},

	mounted() {
		if (_.has(this.options, "event") && _.isObject(this.options.event)) {
			this.event = _.cloneDeep(this.options.event);
		} else {
			this.showAlert(
				"danger",
				`An unexpected error occurred. Please close this window and try again. If the problem persists, please let us know using the "Feedback Form" link at the bottom of the page.`
			);
		}
		if (_.has(this.options, "user") && _.isObject(this.options.user)) {
			this.user = _.cloneDeep(this.options.user);
		} else if (this.isDealer) {
			// Dealer companies can add write-ins to their company only
			// so we are going to pre-select the company id for them
			this.company = {
				value: this.$root.user.company.id,
				label: this.$root.user.company.name,
				brands: this.$root.user.company.brands.map(brand => ({label: brand.name, value: brand.id})),
			};
		}
	},
};
</script>